import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import './fonts/Square_721_Extended.ttf';
import './fonts/Square_721_R.ttf';
import './fonts/square721r.ttf';

import App from './App';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);

